interface ConfirmState {
    open: boolean;
    title: string;
    message: string;
    onConfirm: (() => void) | null;
}

const initialState: ConfirmState = {
    open: false,
    title: 'Onay',
    message: 'Bu işlemi yapmak istediğinize emin misiniz?',
    onConfirm: null,
};

type ConfirmAction =
    | { type: 'SHOW_CONFIRM'; payload: { title?: string; message: string; onConfirm: () => void } }
    | { type: 'HIDE_CONFIRM' };

const confirmReducer = (state = initialState, action: ConfirmAction): ConfirmState => {
    switch (action.type) {
        case 'SHOW_CONFIRM':
            return {
                open: true,
                title: action.payload.title || 'Onay',
                message: action.payload.message,
                onConfirm: action.payload.onConfirm,
            };
        case 'HIDE_CONFIRM':
            return {...state, open: false, onConfirm: null};
        default:
            return state;
    }
};

export const showConfirm = (payload: { title?: string; message: string; onConfirm: () => void }) => ({
    type: 'SHOW_CONFIRM',
    payload,
});

export const hideConfirm = () => ({
    type: 'HIDE_CONFIRM',
});

export default confirmReducer;
